import { render, staticRenderFns } from "./VentasSinCobrar.vue?vue&type=template&id=16ded06d&"
import script from "./VentasSinCobrar.vue?vue&type=script&lang=js&"
export * from "./VentasSinCobrar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports